import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import RequestCodeForm from "../organisms/forms/requestCode/RequestCodeForm";
import Content from "../templates/wrapper/Content";
import { useNavigate } from "react-router-dom";
import { formattedPhone, getCountryCode } from "../../helpers/utils";

const RequestCode = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const countryCode = getCountryCode();

  const onSubmit = async (values) => {
    const username =
      values.loginMethod === "email"
        ? values.email
        : formattedPhone(values.phone_number, countryCode);
    localStorage.setItem("username", username);
    await authContext.sendCode(username);
    navigate("/forgot-password", {
      state: {
        formData: values,
      },
    });
  };

  return (
    <>
      <Content>
        <RequestCodeForm onSubmit={onSubmit} />
      </Content>
    </>
  );
};

export default RequestCode;
